import block from 'bem-cn';
import Button from '../Button/Button';
import InputField from '../InputField/InputField';
import './SignInForm.scss';

const b = block('SignInForm');

const SignInForm = () => {
  return (
    <form className={b()}>
      <div className={b('wrapper')}>
        <h2 className={b('caption')}>Вход</h2>
        <ul className={b('inputs')}>
          <li className={b('email')}>
            <InputField type={'email'} placeholder={'E-mail'} />
          </li>
          <li className={b('password')}>
            <InputField type={'password'} placeholder={'Пароль'} /></li>
        </ul>
        <Button width100 text='Войти' />
      </div>
    </form>
  );
}

export default SignInForm;